import { InputText } from 'primereact/inputtext';

type TextInputProps = {
  id?: any;
  label?: string | null;
  type?: string;
  name: string;
  value?: string;
  className?: string;
  placeholder?: string;
  onChange?: any;
  classSpan?: string;
  maxLength?: number;
  disabled?: boolean;
  inputMode?:
    | 'text'
    | 'numeric'
    | 'decimal'
    | 'tel'
    | 'email'
    | 'search'
    | 'url'
    | 'none'
    | undefined;
};

export const InputComponent = (props: TextInputProps) => {
  const {
    id,
    label,
    type,
    name,
    value,
    className,
    placeholder,
    onChange,
    maxLength,
    disabled,
    inputMode,
  } = props;

  const hasHeightClass = className?.match(/(?:^|\s)h-\[.*?\]|(?:^|\s)h-(\d+)/);
  const classCss = className || 'p-inputtext-sm';
  const inputClass = hasHeightClass ? classCss : `${classCss} !h-12 `;

  return (
    <div className="flex w-full flex-col justify-center ">
      <>
        {' '}
        {label !== undefined ? (
          <p className="text-md  font-bold text-grey">{label}</p>
        ) : (
          <></>
        )}{' '}
      </>

      <InputText
        id={id}
        type={type}
        maxLength={maxLength}
        name={name}
        value={value}
        placeholder={placeholder}
        className={inputClass}
        onChange={onChange}
        disabled={disabled}
        inputMode={inputMode}
        autoComplete="off"
      />
    </div>
  );
};
